import React from 'react';
import './Modal.css';

const PayConfirmModal = ({ isOpen, cupl, onClose, onConfirm, loading, tramiteValue }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => !loading && onClose()}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>💳 Confirmar Pago</h2>
        </div>

        <div className="modal-body">
          <p>¿Estás seguro de que deseas marcar este CUPL como pagado?</p>
          {cupl && (
            <div className="cupl-preview">
              <div className="preview-item">
                <span className="label">CUPL:</span>
                <span className="value">{cupl.cupl_number}</span>
              </div>
              <div className="preview-item">
                <span className="label">Placa:</span>
                <span className="value">{cupl.plate}</span>
              </div>
              <div className="preview-item">
                <span className="label">Propietario:</span>
                <span className="value">{cupl.owner_name}</span>
              </div>
              <div className="preview-item">
                <span className="label">Trámite:</span>
                <span className="value">{cupl.tramite_name}</span>
              </div>
              <div className="preview-item pay-amount">
                <span className="label">Monto a Pagar:</span>
                <span className="value pay-value">
                  ${cupl.tramite_value?.toLocaleString('es-CO') || '0'}
                </span>
              </div>
            </div>
          )}
          <p className="info-text">✓ Una vez marcado como pagado, el registro no podrá ser editado o eliminado.</p>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-pay"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? '⏳ Procesando pago...' : '✓ Marcar como Pagado'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayConfirmModal;
